module.exports = __webpack_public_path__ + "static/img/logo.acb7faa7.png";